var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEmail(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 63,
    height: 62,
    viewBox: "0 0 63 62",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.25,
    width: 62,
    height: 62,
    rx: 31,
    fill: "#0F5BF1"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.25 41.5L26 31M45.25 41.5L36.5 31M15.5 24L28.1437 32.4291C29.2663 33.1776 29.8277 33.5518 30.4344 33.6972C30.9705 33.8256 31.5295 33.8256 32.0656 33.6972C32.6723 33.5518 33.2337 33.1776 34.3563 32.4291L47 24M21.1 43.25H41.4C43.3602 43.25 44.3403 43.25 45.089 42.8685C45.7475 42.533 46.283 41.9975 46.6185 41.339C47 40.5903 47 39.6102 47 37.65V24.35C47 22.3898 47 21.4097 46.6185 20.661C46.283 20.0025 45.7475 19.467 45.089 19.1315C44.3403 18.75 43.3602 18.75 41.4 18.75H21.1C19.1398 18.75 18.1597 18.75 17.411 19.1315C16.7525 19.467 16.217 20.0025 15.8815 20.661C15.5 21.4097 15.5 22.3898 15.5 24.35V37.65C15.5 39.6102 15.5 40.5903 15.8815 41.339C16.217 41.9975 16.7525 42.533 17.411 42.8685C18.1597 43.25 19.1398 43.25 21.1 43.25Z",
    stroke: "white",
    strokeWidth: 2.6875,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmail);
export default __webpack_public_path__ + "static/media/Email.70693a176935c705bea510c3945ae937.svg";
export { ForwardRef as ReactComponent };